<ng-container *ngFor="let tableFilterTemplate of tableFilterTemplates" [ngTemplateOutlet]="tableFilterTemplate"></ng-container>
